/**
 * Supabase REST — turnuva ve maç yükleme (Bearer token ile).
 * Replay JSON büyük olduğu için Storage'a yüklenir; matches tablosunda sadece replay_storage_path tutulur.
 */

const URL = process.env.REACT_APP_SUPABASE_URL
const KEY = process.env.REACT_APP_SUPABASE_ANON_KEY
const STORAGE_BUCKET = 'replays'

function restUrl(table) {
    return (URL || '').replace(/\/$/, '') + '/rest/v1/' + encodeURIComponent(table)
}

function headers(accessToken) {
    const h = {
        apikey: KEY,
        'Content-Type': 'application/json',
        Prefer: 'return=representation',
    }
    if (accessToken) h.Authorization = 'Bearer ' + accessToken
    return h
}

/**
 * Replay JSON'u Storage'a yükler. Path: {uuid}.json
 * Supabase Storage: path URL'de, body raw (application/octet-stream veya application/json).
 * @returns {{ path: string } | { error: string }}
 */
export async function uploadReplayToStorage(accessToken, replayJson) {
    if (!URL || !KEY || !accessToken) return { error: 'Yapılandırma veya oturum eksik' }
    const uuid = typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `t${Date.now()}-${Math.random().toString(36).slice(2, 11)}`
    const path = `${uuid}.json`
    const body = typeof replayJson === 'string' ? replayJson : JSON.stringify(replayJson)
    const base = (URL || '').replace(/\/$/, '')
    // Path URL'de: /storage/v1/object/replays/uuid.json
    const uploadUrl = base + '/storage/v1/object/' + encodeURIComponent(STORAGE_BUCKET) + '/' + encodeURIComponent(path)
    const res = await fetch(uploadUrl, {
        method: 'POST',
        headers: {
            apikey: KEY,
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
            'x-upsert': 'true',
        },
        body,
    })
    if (!res.ok) {
        const errText = await res.text()
        return { error: errText || res.statusText }
    }
    return { path }
}

/**
 * Turnuvalar Supabase üzerinden manuel oluşturulur.
 * Sadece tournament_members tablosunda kullanıcı–turnuva eşleşmesi olan turnuvalar döner (bu turnuvalara maç yüklenebilir).
 */
export async function getMyTournaments(accessToken, userId) {
    if (!URL || !KEY || !accessToken || !userId) return null
    const memberRes = await fetch(restUrl('tournament_members') + '?select=tournament_id&user_id=eq.' + encodeURIComponent(userId), {
        method: 'GET',
        headers: headers(accessToken),
    })
    if (!memberRes.ok) return []
    const memberships = await memberRes.json()
    const ids = Array.isArray(memberships) ? memberships.map(m => m.tournament_id).filter(Boolean) : []
    if (ids.length === 0) return []
    const idList = ids.map(id => encodeURIComponent(String(id))).join(',')
    const q = '?select=*&order=name.asc&id=in.(' + idList + ')'
    const res = await fetch(restUrl('tournaments') + q, {
        method: 'GET',
        headers: headers(accessToken),
    })
    if (!res.ok) return []
    const data = await res.json()
    return Array.isArray(data) ? data : []
}

export async function uploadMatch(accessToken, tournamentId, payload) {
    const { title, match_date, map_name, replay_json } = payload || {}
    if (!URL || !KEY || !accessToken || !tournamentId || !replay_json) return { error: 'Eksik veri' }

    const storageResult = await uploadReplayToStorage(accessToken, replay_json)
    if (storageResult.error) return { error: 'Replay yüklenemedi: ' + storageResult.error }

    const body = {
        tournament_id: tournamentId,
        title: (title && String(title).trim()) || '',
        replay_storage_path: storageResult.path,
    }
    if (map_name) body.map_name = map_name
    if (match_date) body.match_date = match_date
    const res = await fetch(restUrl('matches'), {
        method: 'POST',
        headers: headers(accessToken),
        body: JSON.stringify(body),
    })
    if (!res.ok) {
        const err = await res.json().catch(() => ({}))
        return { error: err.message || res.statusText }
    }
    const data = await res.json()
    const row = Array.isArray(data) ? data[0] : data
    return { data: row, error: null }
}



// WEBPACK FOOTER //
// ./src/lib/supabaseUpload.js